<template>
  <BasePagination
    v-bind="$attrs"
    v-on="$listeners"
    v-model="page"
    :styleConfig="styleConfig"
  >
    <template v-slot:first-page-button>
      <slot name="first-page-button" />
    </template>
    <template v-slot:previous-page-button>
      <slot name="previous-page-button" />
    </template>
    <template v-slot:page-button="props">
      <slot
        v-bind="props"
        name="page-button"
      />
    </template>
    <template v-slot:ellipsis>
      <slot name="ellipsis" />
    </template>
    <template v-slot:next-page-button>
      <slot name="next-page-button" />
    </template>
    <template v-slot:last-page-button>
      <slot name="last-page-button" />
    </template>
  </BasePagination>
</template>

<script>
  import BasePagination from '@base/v2/base-pagination'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'PaginationPrimary',
    inheritAttrs: false,
    model: {
      prop: 'vmodelValue',
      event: 'change',
    },
    components: {
      BasePagination,
    },
    props: {
      vmodelValue: {
        type: [Object, Number],
        required: false,
        default: null,
      },
    },
    data: function () {
      return {
        page: this.vmodelValue,
        style: {
          button: {
            alignItems: 'center',
            borderRadius: Layout.space.xs,
            cursor: {
              '': 'pointer',
              disabled: 'default',
            },
            display: 'flex',
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.md,
            fontWeight: {
              '': FontStyle.weight.md,
              selected: FontStyle.weight.lg,
            },
            height: '32px',
            justifyContent: 'center',
            margin: `0 ${Layout.space.xs}`,
            userSelect: 'none',
            width: '32px',
          },
        },
        styleConfig: {
          container: {},
          ellipsis: {
            height: '32px',
            width: '32px',
          },
          firstPageButton: {},
          lastPageButton: {},
          nextPageButton: {},
          pageButton: {},
          pages: {},
          previousPageButton: {},
        },
      };
    },
    created: function () {
      Object.assign(
        this.style.button,
        {
          backgroundColor: {
            '': this.color.light1(),
            hover: this.color.dark6(),
            active: this.color.dark6(),
            selected: this.color.dark6(),
            disabled: this.color.light1(),
          },
          border: {
            '': `solid ${this.color.dark4()}`,
            disabled: `solid ${this.color.dark5()}`,
          },
          borderWidth: '1px',
          color: {
            '': this.color.dark2(),
            disabled: this.color.dark4(),
          },
        },
      );

      Object.assign(
        this.styleConfig.ellipsis,
        {
          color: {
            '': this.color.dark2(),
            disabled: this.color.dark4(),
          },
        },
      );

      Object.assign(
        this.styleConfig.firstPageButton,
        {
          ...this.style.button,
        },
      );
      Object.assign(
        this.styleConfig.lastPageButton,
        {
          ...this.style.button,
        },
      );
      Object.assign(
        this.styleConfig.nextPageButton,
        {
          ...this.style.button,
        },
      );
      Object.assign(
        this.styleConfig.pageButton,
        {
          ...this.style.button,
        },
      );
      Object.assign(
        this.styleConfig.previousPageButton,
        {
          ...this.style.button,
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
    watch: {
      vmodelValue: function (newVal, oldVal) {
        this.page = newVal;
      },
    },
  };
</script>

